import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const createCancellationCoupon = (apiUrl) => () => {
  const url = joinUrl(
    apiUrl,
    `/checkoutservice/pb/users/me/create-package-cancellation-coupon/`
  );
  return requestUtility.post(url);
};

export default createCancellationCoupon;
